import { Button, Modal } from "react-bootstrap";

type Props = {
  show: boolean;
  title: string;
  content: string | React.ReactNode;
  btnText?: string;
  variant?: string;
  handleSubmit: () => void;
  handleClose: () => void;
};

const ConfirmModal: React.FC<Props> = ({
  show,
  title,
  content,
  variant = "primary",
  btnText = "Confirm & Proceed",
  handleSubmit,
  handleClose,
}) => {
  return (
    <Modal
      className="modal-mobile-bottom"
      show={show}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={variant == "danger" ? "fw-bold text-danger" : ""}>
          {content}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant={variant} type="button" onClick={handleSubmit}>
          {btnText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
